module.exports = __webpack_public_path__ + "img/violet_125.2ae279d2.png";